export default __webpack_public_path__ + "static/media/SentinelOne_Singularity.f9ce293b.svg";